$(document).on("click",".custom-card .variant-btn",function() {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
});

let lastScrollTop = 0;
$(window).on("scroll", function () {
    let scrollTop = $(this).scrollTop();

    if (scrollTop > lastScrollTop) {
        $(".mobile-sticky-bar_wrapper").addClass("up").removeClass("down");
    } else {
        $(".mobile-sticky-bar_wrapper").addClass("down").removeClass("up");
    }

    lastScrollTop = scrollTop;
});


$(document).on("click",".custom-card .variant-btn",function() {
   var price = $(this).attr("price");
  $(this).parents("product-card").find(".price").text(price);
});

function refresh_cartdrawer(){
    import('@theme/events').then(({ CartUpdateEvent }) => {
      const cartDrawer = document.querySelector('cart-drawer-component');    
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const event = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'fad-refresh',
          sections: {}
        });
        document.dispatchEvent(event);
          cartDrawer.open();
      });
    });
}
  // ATC product
 
$(document).on("click",".custom-atc",function() {
    var selectedVariant = $(this).parents('.custom-card').find(".variant-btn.active").attr("data-variant-id");
    if(selectedVariant){
        var $btn = $(this);
        var text = $btn.text();
        $btn.text("Adding...");
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ id: selectedVariant, quantity: 1 }),
      dataType: 'json',
      contentType: 'application/json',
      success: function(data) {
        refresh_cartdrawer();
        setTimeout(function() {
            //$(".header-actions__cart-icon").trigger("click");
            $btn.text(text);
        }, 1500);
      },
      error: function(err) {
      }
    });
  });